import { CategoryModel } from './CategoryModel';
import { ExpositionModel } from './ExpositionModel';
import { LocationModel } from './LocationModel';
import { PeriodModel } from './PeriodModel';
import { JournalistModel } from './JournalistModel';
import { VehicleModel } from './VehicleModel';
import { UserModel } from './UserModel';
import { ClassificationStatus } from '../Features/Classification/enum/ClassificationStatus';
import { CoverPresenceModel } from './CoverPresenceModel';

export interface ClassificationModel {
    id: number,
    clientId: number,
    newsId: number,
    publicationTitle: string,
    publicationDate: Date | null,
    clipperLink: string,
    originalLink: string,
    vehicleId: number,
    vehicleNomenclature: string,
    vehicleStateInitials: string,
    vehicleDictionary: boolean,
    durationPriceTime: number | null,
    centimeter: number,
    status: ClassificationStatus,
    statusDescription: string,
    startClassification: Date | null,
    endClassification: Date | null,
    includeDate: Date | null,
    lastModificationDate: Date | null,
    userId: number | null,
    responsible: UserModel | null,
    numberOfCategories: number,
    mediaDescription: string,
    mediaId: number,
    clientName: string,

    vehicle: VehicleModel | null,
    journalists: JournalistModel[],
    journalistsNames: string,
    location: LocationModel | null,
    expositions: ExpositionModel[],
    expositionsDescription: string,
    period: PeriodModel | null,
    userCodeMetric: number,    
    clientCodeMetric: number | null,
    coverPresence: CoverPresenceModel | null,

    categories: CategoryModel[],
    metricId: string,
    circulationName: string
}

export const classificationModelInitial: ClassificationModel = {
    id: 0,
    clientId: 0,
    newsId: 0,
    publicationTitle: '',
    publicationDate: null,
    clipperLink: '',
    originalLink: '',
    vehicleId: 0,
    vehicleNomenclature: '',
    vehicleStateInitials: '',
    vehicleDictionary: false,
    durationPriceTime: null,
    centimeter: 0,
    status: ClassificationStatus.REVIEWED,
    statusDescription: 'Revisada',
    includeDate: null,
    lastModificationDate: null,
    startClassification: null,
    endClassification: null,
    userId: null,
    responsible: null,
    numberOfCategories: 0,
    mediaDescription: '',
    mediaId: 0,
    clientName: '',

    vehicle: null,
    journalists: [],
    journalistsNames: '',
    location: null,
    expositions: [],
    expositionsDescription: '',
    period: null,
    userCodeMetric: 0,
    clientCodeMetric: null,
    coverPresence: null,
    
    categories: [],
    metricId: '',

    circulationName: ''
};